import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import getField from '../../utilities/Data/getField'
import { statisticNameFor, statisticValueFor, statisticComparisonFor } from '../../utilities/Data/User/calculateStatistics'
import ExpandableSection from '../ExpandableSection'
import getValueInUnit from '../../utilities/Data/User/getValueInUnit'
import Collection from '../Collection'
import UserImproveBox from './UserImproveBox'
import UserImproveLine from './UserImproveLine'
import styles from './Fit.icss'

const hasNoStatValue = (stats, attrib) => (!stats || !stats[attrib] || !stats[attrib].value || !getValueInUnit(stats[attrib]))

class UserFit extends React.Component {
	constructor(props) {
		super(props)

		this.handleEditStat = this.handleEditStat.bind(this)
		this.handleMakePrivateStat = this.handleMakePrivateStat.bind(this)
		this.handleMakePublicStat = this.handleMakePublicStat.bind(this)
	}

	handleEditStat(stat, statType) {
		const defaultLink = 'statistics'
		const linkableTypes = {
			weight: 'weight',
			waist: 'waist',
			height: 'height',
			chest: 'chest',
			chestShape: 'shape',
			fitPreference: 'shape',
			stomachShape: 'shape'
		}
		const linkPath = linkableTypes[statType] ? linkableTypes[statType] : defaultLink
		this.props.appRedirect(`/edit${linkPath}`)
	}

	handleMakePrivateStat(stat) {
		console.log('handleMakePrivateStat', this.props.ownUserProfile.uid, stat)
	}

	handleMakePublicStat(stat) {
		console.log('handleMakePublicStat', this.props.ownUserProfile.uid, stat)
	}

	editLabelForStat(statType) {
		const defaultLabel = this.context.translate('Add yours')
		const editableTypes = {
			chest: this.context.translate('Add your chest'),
			chestShape: this.context.translate('Add your shape'),
			dateOfBirth: this.context.translate('Add your DOB'),
			fitPreference: this.context.translate('Add your fit'),
			height: this.context.translate('Add your height'),
			stomachShape: this.context.translate('Add your shape'),
			waist: this.context.translate('Add your waist'),
			weight: this.context.translate('Add your weight')
		}
		return editableTypes[statType] ? editableTypes[statType] : defaultLabel
	}

	render() {
		const { userProfile, ownUserProfile } = this.props
		const isOwnProfile = userProfile.uid === ownUserProfile.uid

		return (
			<ExpandableSection title={isOwnProfile ? this.context.translate('Stats') : this.context.translate('Your stats vs {user}', { user: userProfile.userName })} defaultExpanded>
				<Collection
					items={
						userProfile.statistics ?
							Object.keys(userProfile.statistics).filter(key => !hasNoStatValue(userProfile.statistics, key)).reduce((a, key) => ({ ...a, [key]: userProfile.statistics[key] }), {}) :
							[]
					}
					contextMenuItems={() => [
						{
							name: this.context.translate('Edit'),
							handler: this.handleEditStat
						}
					// ,stat.isPublic ?
					// 	{
					// 		name: this.context.translate('Make Private'),
					// 		handler: this.handleMakePrivateStat
					// 	} :
					// 	{
					// 		name: this.context.translate('Make Public'),
					// 		handler: this.handleMakePublicStat
					// 	}
					]}
					classes={{ itemRoot: isOwnProfile ? styles.itemOwnProfile : styles.itemOtherProfile }}
					renderItemFragment={({ item: stat, key, onContextClick }) => {
						const statName = statisticNameFor(key)
						const statUser = getField(ownUserProfile, 'statistics', key) // viewing user's stat
						const statUnit = getField(statUser || stat, 'unit') // display is to be in the viewing user's preferred unit
						const statValue = getValueInUnit(stat, statUnit)
						const statDisplay = statisticValueFor(statUnit).display(statValue)

						if (isOwnProfile) {
							return (
								<React.Fragment>
									<div>{statName}</div>
									<div className={styles.statDisplay}>{statDisplay}</div>
									<div className={styles.contextBtn}>
										<IconButton aria-label="Context" onClick={onContextClick}>
											<MoreVertIcon />
										</IconButton>
									</div>
								</React.Fragment>
							)
						}

						const statUserValue = getValueInUnit(statUser, statUnit)
						const statOtherValueSmaller = statisticValueFor(statUnit).diff(statUserValue, statValue) > 0
						const statOtherValueBigger = statisticValueFor(statUnit).diff(statUserValue, statValue) < 0
						const statValuesEqual = !statOtherValueSmaller && !statOtherValueBigger
						const statValueDiff = statOtherValueSmaller ? statisticValueFor(statUnit).diff(statUserValue, statValue) : statisticValueFor(statUnit).diff(statValue, statUserValue)
						const statValueDiffDisplay = statisticValueFor(statUnit).diffDisplay(statValueDiff)
						const statOtherFlex = statOtherValueBigger ? statValueDiff : statisticValueFor(statUnit).relative(statValue)
						const statUserFlex = statOtherValueSmaller ? statValueDiff : statisticValueFor(statUnit).relative(statUserValue)
						return (
							<React.Fragment>
								<div className={styles.itemRow}>
									<div className={styles.itemColumn0}>
										<div className={styles.statName}>{statName}</div>
										{statUser && statOtherValueSmaller && <div className={styles.statDifference}>{statisticComparisonFor(key).bigger(statValueDiffDisplay)}</div>}
										{statUser && statOtherValueBigger && <div className={styles.statDifference}>{statisticComparisonFor(key).smaller(statValueDiffDisplay)}</div>}
										{statUser && statValuesEqual && <div className={styles.statDifference}>{statisticComparisonFor(key).equal}</div>}
									</div>
									<div className={styles.itemColumn1}>
										<div className={styles.statDisplay}>{statDisplay}</div>
										{statUser && (
											<div>
												<div className={styles.statBar}>
													{statOtherValueSmaller && <div className={styles.statBarOther} style={{ flex: statOtherFlex }} />}
													<div className={styles.statBarUser} style={{ flex: statUserFlex }} />
													{statOtherValueBigger && <div className={styles.statBarOther} style={{ flex: statOtherFlex }} />}
												</div>
											</div>
										)}
									</div>
								</div>
								{!statUser && (
									<div className={styles.itemRow}>
										<UserImproveLine
											className={styles.itemColumnImproveLine}
											handleEdit={() => {
												this.handleEditStat(key)
											}}
											label={this.editLabelForStat(key)}
										/>
									</div>
								)}
							</React.Fragment>
						)
					}}
				/>
				<UserImproveBox userProfile={ownUserProfile} appRedirect={this.props.appRedirect} />
			</ExpandableSection>
		)
	}
}

UserFit.propTypes = {
	userProfile: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	ownUserProfile: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appRedirect: PropTypes.func.isRequired
}

UserFit.contextTypes = {
	translate: PropTypes.func
}

export default UserFit



// WEBPACK FOOTER //
// ./src/components/User/Fit.jsx